import { IndexBlogPostCardProps } from '@/types';
import Image from 'next/image';
import Link from 'next/link';
import { FaRegClock } from 'react-icons/fa';
import { getBlogContributorImage } from '@/utilites/blogs/blogs.utils';
import { ImagesPressLogosGoldBlueSpiritoryLogoSvg } from '@/assets/images_press_logos_gold-blue.assets';
export default function IndexBlogPostCard({ blogPost, browserLocale }: IndexBlogPostCardProps) {
  const {
    id = '',
    attributes: {
      title = '',
      slug = '',
      description = '',
      thumbnailImage,
      reading_time = '',
      createdAt = new Date().toLocaleDateString(),
      contributor,
    },
  } = blogPost;

  const blogThumbnailImage = thumbnailImage?.data?.attributes.url ?? '';
  const blogContributor = contributor?.data?.attributes?.name ?? '';
  const blogContributorImage = contributor?.data?.attributes?.image.data?.attributes.url ?? '';
  const contributorLongDescription =
    contributor?.data?.attributes?.long_description && contributor?.data?.attributes?.slug
      ? `/blog/authors/${contributor?.data?.attributes?.slug}`
      : '';

  const contributorSlug = contributor?.data?.attributes?.slug ?? '';

  return (
    <div className="tw-relative tw-flex tw-h-full tw-flex-col tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 tw-bg-white tw-shadow-sm">
      {' '}
      <Link href={`/blog/${slug}`} className="tw-relative tw-block tw-rounded-xl">
        <Image
          src={blogThumbnailImage}
          alt={title}
          width={427}
          height={196}
          className="tw-aspect-[427/196] tw-w-full tw-rounded-tl-xl tw-rounded-tr-xl tw-object-cover"
        />
        <div className="tw-absolute tw-bottom-2 tw-right-2 tw-rounded-[4px] tw-bg-white/70 tw-px-[8px] tw-py-[4px]">
          <p className="tw-m-0 tw-flex tw-items-center tw-justify-center tw-gap-1 tw-whitespace-nowrap tw-p-0 tw-text-sm tw-font-medium tw-text-text/80 max-nine:tw-text-xs">
            <FaRegClock className="tw-mr-1 tw-h-[24px] tw-w-[24px] max-nine:tw-h-3 max-nine:tw-w-3" />
            {reading_time} Min
          </p>
        </div>
      </Link>
      <div className="tw-mb-4 tw-mt-6 tw-flex tw-h-full tw-flex-grow tw-flex-col tw-justify-between tw-px-4">
        {/* [TODO] - check category */}
        <div className="tw-flex tw-flex-col">
          <Link
            href={`/blog/${slug}`}
            className="tw-mb-3 tw-line-clamp-2 tw-p-0 tw-text-base tw-font-bold tw-leading-normal tw-text-text tw-underline-offset-4 max-nine:tw-mb-3 max-nine:tw-pb-0.5 max-nine:tw-text-sm max-nine:tw-font-semibold max-nine:tw-text-text"
          >
            {title}
          </Link>
          <p className="tw-line-clamp-3 tw-p-0 tw-text-[15px] tw-font-normal tw-leading-[normal] tw-text-[#4F5A67] max-nine:tw-text-[14px]">
            {description}
          </p>
        </div>
        <div className="tw-flex tw-items-center tw-justify-between">
          <p className="tw-m-0 tw-p-0 tw-text-[15px] tw-font-medium tw-text-[#4F5A67] max-nine:tw-text-xs-custom max-nine:tw-leading-[16.38px] max-nine:tw-text-charcoal-blue">
            {new Date(createdAt).toLocaleDateString(browserLocale)}
          </p>
          <Link
            href={contributorSlug ? `/blog/authors/${contributorSlug}` : `/blog/authors`}
            className="tw-flex tw-items-center tw-gap-4 tw-text-text tw-underline tw-underline-offset-4"
          >
            <p className="tw-m-0 tw-p-0 tw-text-sm tw-font-semibold tw-text-text max-nine:tw-text-xs-custom max-nine:tw-font-medium max-nine:tw-leading-[16.38px] max-nine:tw-text-charcoal-blue max-nine:tw-underline max-nine:tw-underline-offset-4">
              {blogContributor}
            </p>
            <Image
              src={getBlogContributorImage(blogContributorImage)}
              alt={blogContributor}
              width={40}
              height={40}
              className="tw-aspect-square tw-h-10 tw-w-10 tw-shrink-0 tw-rounded-full max-nine:tw-h-7 max-nine:tw-w-7"
              onError={e => {
                e.currentTarget.src = ImagesPressLogosGoldBlueSpiritoryLogoSvg.src;
                e.currentTarget.srcset = ImagesPressLogosGoldBlueSpiritoryLogoSvg.src;
                e.currentTarget.alt = 'Spiritory Logo';
              }}
            />
          </Link>
        </div>
      </div>
    </div>
  );
}
